class MarqueeTicker extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.js-marquee-track');
    this.resizeObserver = null;
  }

  connectedCallback() {
    if (!this.track) return;

    this.initMarquee();

    this.resizeObserver = new ResizeObserver(() => {
      this.initMarquee();
    });

    this.resizeObserver.observe(this);
    this.resizeObserver.observe(this.track);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initMarquee() {
    const existingClones = this.querySelectorAll('.js-marquee-clone');
    existingClones.forEach((clone) => clone.remove());

    const originalItems = this.track.querySelectorAll('.scrolling-text__item');
    if (!originalItems.length) return;

    const setWidth = this.track.scrollWidth;
    const screenWidth = this.offsetWidth || window.innerWidth;

    if (setWidth <= 0) return;

    const minWidthNeeded = screenWidth * 2;
    const copiesNeeded = Math.max(2, Math.ceil(minWidthNeeded / setWidth));

    for (let i = 1; i < copiesNeeded; i++) {
      for (const item of originalItems) {
        const clone = item.cloneNode(true);
        clone.classList.add('js-marquee-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        this.track.appendChild(clone);
      }
    }

    this.style.setProperty('--total-tracks', copiesNeeded);

    const speedSetting = parseFloat(this.dataset.speed) || 20;
    const normalizedDuration = (setWidth / 1000) * speedSetting;
    this.style.setProperty('--ticker-speed', `${normalizedDuration}s`);
  }
}

if (!customElements.get('scrolling-text')) {
  customElements.define('scrolling-text', MarqueeTicker);
}
